import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { repairAppliances } from '../mock';

const RepairCare = () => {
  return (
    <section className="py-16 md:py-24 bg-[#FFF6EB]">
      <div className="max-w-7xl mx-auto px-5">
        <div className="bg-white rounded-[36px] p-6 sm:p-8 md:p-14 border border-[#1F0068]/5">
          <div className="max-w-3xl">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1F0068] tracking-tight leading-tight">
              For an initial repair and ongoing maintenance and support, get a <span className="text-[#FF5C39]">Repair & Care</span> plan
            </h2>
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2.5 md:gap-3">
            {repairAppliances.map((a) => (
              <Link
                key={a}
                to={`/quote?appliance=${encodeURIComponent(a)}`}
                data-testid={`repair-appliance-${a.toLowerCase().replace(/\s+/g, '-')}`}
                className="group flex items-center justify-between gap-2 px-4 sm:px-5 py-3 sm:py-4 rounded-2xl bg-[#FFF6EB] hover:bg-[#1F0068] hover:text-white text-[#1F0068] transition-colors min-w-0"
              >
                <span className="font-semibold text-xs sm:text-sm truncate">{a}</span>
                <ArrowRight className="w-4 h-4 shrink-0 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 transition-all" />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RepairCare;
